import React, { useEffect, useState } from "react";
import {
  Form, Input, Select, Button, Steps, Upload,
  Tag, Space, Typography, Row, Col, Divider,
  App, Card, Spin,message
} from "antd";
import {
  MailOutlined, LinkedinOutlined,
  UploadOutlined, PlusOutlined, ArrowLeftOutlined, ArrowRightOutlined,
  SendOutlined, ClearOutlined, LoadingOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import trackhrlogo from "../../assets/trackhrlogo.png";
import countrycode from "../../utility/countrycode.json";
import Hexapi from "../../utility/HexAPI/Hexapi";
import FormField from "../../component/fields/Inputbox";
import { showConfirm } from "../../utility/showconfirm";
import dayjs from "dayjs";
import STEPSdata from "./steps";
import { Modal } from "react-bootstrap";
import { ViewComponent } from "../../component/attachment/ViewComponent";
import { FaEye } from "react-icons/fa";
import { IconButton, Tooltip } from "@mui/material";
const { Title, Text } = Typography;
const { Option } = Select;

const INITIAL_FORM = {
  fullname: "",
  dob: null,
  gender: undefined,
  nationality: "Indian",
  currentaddress: "",
  email: "",
  countrycodecontact: "+91",
  contactnumber: "",
  countrycodealt: "+91",
  alternateno: "",
  linkedin: "",
  currentdesignation: "",
  currentcompany: "",
  totalexperience: undefined,
  noticeperiod: "",
  currentctc: "",
  expectedctc: "",
  qualification: undefined,
  stream: "",
  institute: "",
  passingyear: "",
  appliedposition: "",
  department: undefined,
  source: undefined,
  referredby: "",
  priority: "",
  StageID:2,
  remarks: "",

};

const STEPS = STEPSdata;

export default function CustomerEnquiryform({ open = false, onClose, agentID,refreshtableadd , candidateID}) {
  const [form] = Form.useForm();
  const [activeSection, setActiveSection] = useState(0);
  const [skills, setSkills] = useState([]);
  const [skillInput, setSkillInput] = useState("");
  const [resumeFile, setResumeFile] = useState(null);
  const [isresume,setisresume]=useState(false)
  const [formData, setFormData] = useState({
    stage: [],
    skillname: [],
    qualification: [],
    department: [],
    source: [],
    experience: [],
    appliedpositionfor:[]
  });
  const [isresumevalue,setisresumevalue]=useState(false)
  const [formDataLoading, setFormDataLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [IsEdit,setIsEdit]=useState(candidateID)
  const [existingResumeId, setExistingResumeId] = useState(null);
  const [openattachment,setopenatachment]=useState(false)
    const getformData = async () => {
    try {
      setFormDataLoading(true);
      const obj = {
        query: `[dbo].[HCMS_Proc_Candidate_Add_getFormData] @AgentID='{0}'`,
        queryArr: [`${agentID}`],
      };
      const resp = await Hexapi(obj);
      console.log(resp, "getformdataresp");
      if (resp) {
        setFormData({
          stage: resp.stage || [],
          skillname: resp.skillname || [],
          qualification: resp.qualification || [],
          department: resp.department || [],
          source: resp.source || [],
          experience: resp.experience || [],
          appliedpositionfor:resp?.appliedpositionfor || []
        });
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setFormDataLoading(false);
    }
  };

  useEffect(() => {
    getformData();
  }, [agentID]);
const GetEditformData = async () => {
  if (!agentID || !candidateID) return;

  try {
    const obj = {
      query: `HCMS_Proc_EditCandidate_getFormData @agentID='{0}',@CandidateID='{1}'`,
      queryArr: [`${agentID}`, `${candidateID}`],
    };

    const resp = await Hexapi(obj);

    const raw = resp?.[""]?.[0];

    console.log(raw, "raw");

    if (!raw) return;

   
    const findIdByLabel = (list, value) => {
      if (!value) return undefined;

      const item = list?.find(
        (x) =>
          x.label?.toString().trim().toLowerCase() ===
          value?.toString().trim().toLowerCase()
      );

      return item?.recid;
    };

    const mapped = {
      fullname: raw.fullname || "",
      dob: raw?.dob?.date ? dayjs(raw.dob?.date) : null,
      gender: raw.gender ?? undefined,
      nationality: raw.nationality || "Indian",
      currentaddress: raw.currentaddress || "",
      email: raw.email || "",
      countrycodecontact: raw.countrycode || "+91",
      contactnumber: raw.phonenumber || "",
      countrycodealt: "+91",
      alternateno: raw.alternatenumber || "",

      linkedin: raw.linkedin || "",

      currentdesignation: raw.currentdesignation || "",

      currentcompany: raw.currentcompany || "",

     
      totalexperience: raw.totalexperience || undefined,

      noticeperiod: raw.noticeperiod || "",

      currentctc: raw.currentctc || "",

      expectedctc: raw.expectedctc || "",

      qualification: raw.qualification || undefined,

      stream: raw.stream || "",

      institute: raw.institute || "",

      passingyear: raw.passingyear || "",

     
      appliedposition: raw.appliedposition
        ? findIdByLabel(
            formData.appliedpositionfor,
            raw.appliedposition
          )
        : undefined,

      department:
        raw.departmentid == 0
          ? undefined
          : raw.departmentid,

      source: raw.leadsourceid || undefined,

      referredby: raw.referredby || "",

      priority: raw.priority || "",

      StageID: raw.stageid || undefined,

      remarks: raw.remarks || "",
    };

    setTimeout(() => {
      form.setFieldsValue(mapped);
    }, 0);

    console.log(raw.skills,"skillsssssss")
 if (raw.skills) {
  const skillArr = raw.skills
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  const mappedSkills = skillArr.map((skillId) => {
    const found = formData.skillname.find(
      (x) => String(x.recid) === String(skillId)
    );

    return found
      ? {
          recid: found.recid,
          label: found.label,
        }
      : {
          recid: skillId,
          label: skillId,
        };
  });

  setSkills(mappedSkills);
  console.log(raw?.resumeid,"resumeiddddddd")
 const resumeId = raw?.resumeid?.trim();
console.log(resumeId,"resumeId")

if (resumeId && resumeId != null  && raw?.filename != null) {
  setisresume(true);
  setResumeFile({
    name:`${raw?.filename}`
  })
  setExistingResumeId(resumeId);
  setisresumevalue(true);
}else{
  setisresume(false)
  setExistingResumeId(null)
}
}
    
   
  } catch (error) {
    console.error("GetEditformData error:", error);
  }
};

useEffect(() => {
  if (
    candidateID &&
    formData.skillname.length > 0
  ) {
    GetEditformData();
  }
}, [candidateID, formData]);
  const addSkill = (skillObj) => {
    if (!skillObj) {
      const trimmed = skillInput.trim();
      if (!trimmed || skills.find((s) => s.label === trimmed)) return;
      setSkills((prev) => [...prev, { recid: null, label: trimmed }]);
      setSkillInput("");
      return;
    }
    if (skills.find((s) => s.label === skillObj.label)) return;
    setSkills((prev) => [...prev, skillObj]);
  };

  const removeSkill = (label) =>
    setSkills((prev) => prev.filter((s) => s.label !== label));

  const validateStep = async (stepIndex) => {
    const fieldMap = {
      0: ["fullname"],
      1: ["email", "contactnumber"],
      2: [],
      3: [],
      4: [],
      5: ["appliedposition", "source", "StageID"],
    };
    try {
      await form.validateFields(fieldMap[stepIndex]);
      return true;
    } catch {
      return false;
    }
  };

  const goNext = async () => {
    const valid = await validateStep(activeSection);
    if (valid) setActiveSection((s) => Math.min(s + 1, STEPS.length - 1));
  };

  const goBack = () => setActiveSection((s) => Math.max(s - 1, 0));
  const getresumeid = async (file) => {
    if (!file) return null;
    const extension = "." + /[^.]+$/g.exec(file.name)[0];
    const obj = {
      query: `[dbo].[HCMS_Proc_Add_Attachment]@AgentID='{0}',@Extension='{1}',@FileName='{2}',@Attachment=$%$File$%$`,
      queryArr: [`${agentID}`, `${extension}`, `${file.name}`],
      file: file,
    };
    const resp = await Hexapi(obj);
    return resp?.[""]?.[0]?.attachmentid || null;
  };
  const geteditresume = async (file) => {
    console.log(existingResumeId,"iddd")
    if (!file) return null;
    const extension = "." + /[^.]+$/g.exec(file.name)[0];
    const obj = {
      query: `[dbo].[HCMS_Proc_Edit_Attachment]@AgentID='{0}',@Extension='{1}',@FileName='{2}',@AttachmentID='{3}',@Attachment=$%$File$%$`,
      queryArr: [`${agentID}`, `${extension}`, `${file.name}`,`${existingResumeId}`],
      file: file,
    };
    const resp = await Hexapi(obj);
    return resp?.[""]?.[0]?.attachmentid || null;
  };
const handleSubmit = async () => {
  console.log(candidateID,"ghhjkjjokbjknjl")
  console.log(form.getFieldValue,"formm")
  try {
      setSubmitLoading(true);

    const allStepFields = {
      0: ["fullname"],
      1: ["email", "contactnumber"],
      2: [],
      3: [],
      4: [],
      5: ["appliedposition", "source", "StageID"],
    };

    const stepErrors = [];

    for (const [stepIndex, fields] of Object.entries(allStepFields)) {
      if (fields.length === 0) continue;

      try {
        await form.validateFields(fields);
      } catch (errorInfo) {
        const stepNum = parseInt(stepIndex);

        const stepTitle =
          STEPS[stepNum]?.title || `Step ${stepNum + 1}`;

        const errorMessages =
          errorInfo.errorFields
            ?.map((f) => f.errors?.[0])
            .filter(Boolean) || [];

        if (errorMessages.length > 0) {
          stepErrors.push({
            stepTitle,
            errors: errorMessages,
          });
        }
      }
    }


    if (!resumeFile && !existingResumeId) {
      setisresume(true);

      stepErrors.push({
        stepTitle: "Resume Upload",
        errors: ["Please upload resume / CV"],
      });
    } else {
      setisresume(false);
    }


    if (stepErrors.length > 0) {
     await showConfirm({
                content: (
                 <div style={{ marginTop: 8 }}>
                   {stepErrors.map(({ stepTitle, errors }) => (
                     <div key={stepTitle} style={{ marginBottom: 12 }}>
                       <Text
                         strong
                         style={{
                           color: "#ff4d4f",
                           fontSize: 13,
                         }}
                       >
                         📌 {stepTitle}
                       </Text>
     
                       <ul
                         style={{
                           margin: "4px 0 0 0",
                           paddingLeft: 20,
                         }}
                       >
                         {errors.map((err, i) => (
                           <li
                             key={i}
                             style={{
                               fontSize: 13,
                               color: "#595959",
                               marginBottom: 2,
                             }}
                           >
                             {err}
                           </li>
                         ))}
                       </ul>
                     </div>
                   ))}
                 </div>
               ),
               title: "Please fix the following errors before submitting",
               hideCancel:true,
               okText:"OK"
             })

      setSubmitLoading(false);
      return;
    }

    const resumeid = (isresumevalue && existingResumeId && existingResumeId != null) ? await geteditresume(resumeFile) :  await getresumeid(resumeFile);
console.log(form,"form")
    const values = form.getFieldsValue(true);

    console.log(values, "values");
let obj;

if(candidateID){
obj = {
      query: `[dbo].[HCMS_Proc_Edit_Candidate]
    @AgentID='{0}', @FullName='{1}', @DOB='{2}', @Gender='{3}', @Nationality='{4}',
    @CurrentAddress='{5}', @Email='{6}', @CountryCode='{7}', @ContactNumber='{8}',
    @AlternateNumber='{9}', @LinkedIn='{10}', @CurrentDesignation='{11}',
    @CurrentCompany='{12}', @TotalExperience='{13}', @NoticePeriod='{14}',
    @CurrentCTC='{15}', @ExpectedCTC='{16}', @Qualification='{17}', @Stream='{18}',
    @Institute='{19}', @PassingYear='{20}', @AppliedPosition='{21}',
    @Department='{22}', @Source='{23}', @ReferredBy='{24}', @Priority='{25}',
    @StageID='{26}', @Remarks='{27}', @Skills='{28}', @ResumeID='{29}',@CandidateID='{30}'`,
      queryArr: [
        `${agentID}`, `${values.fullname}`,
        `${values.dob ? values.dob.format("YYYY-MM-DD") : ""}`,
        `${values.gender || ""}`, `${values.nationality || "Indian"}`,
        `${values.currentaddress || ""}`, `${values.email}`,
        `${values.countrycodecontact || "+91"}`, `${values.contactnumber || ""}`,
        `${values.alternateno || ""}`, `${values.linkedin || ""}`,
        `${values.currentdesignation || ""}`, `${values.currentcompany || ""}`,
        `${values.totalexperience || ""}`, `${values.noticeperiod || ""}`,
        `${values.currentctc || 0}`, `${values.expectedctc || 0}`,
        `${values.qualification || ""}`, `${values.stream || ""}`,
        `${values.institute || ""}`, `${values.passingyear || ""}`,
        `${values.appliedposition}`, `${values.department || ""}`,
        `${values.source || ""}`, `${values.referredby || ""}`,
        `${values.priority || ""}`,`${values.StageID}`,
        `${values.remarks || ""}`,
        `${skills.map((s) => s.recid || s.label).join(",") || ""}`,
        `${resumeid}`,`${candidateID}`,
      ],
    };
}else{
 obj = {
      query: `[dbo].[HCMS_Proc_Add_Candidate]
    @AgentID='{0}', @FullName='{1}', @DOB='{2}', @Gender='{3}', @Nationality='{4}',
    @CurrentAddress='{5}', @Email='{6}', @CountryCode='{7}', @ContactNumber='{8}',
    @AlternateNumber='{9}', @LinkedIn='{10}', @CurrentDesignation='{11}',
    @CurrentCompany='{12}', @TotalExperience='{13}', @NoticePeriod='{14}',
    @CurrentCTC='{15}', @ExpectedCTC='{16}', @Qualification='{17}', @Stream='{18}',
    @Institute='{19}', @PassingYear='{20}', @AppliedPosition='{21}',
    @Department='{22}', @Source='{23}', @ReferredBy='{24}', @Priority='{25}',
    @StageID='{26}', @Remarks='{27}', @Skills='{28}', @ResumeID='{29}'`,
      queryArr: [
        `${agentID}`, `${values.fullname}`,
        `${values.dob ? values.dob.format("YYYY-MM-DD") : ""}`,
        `${values.gender || ""}`, `${values.nationality || "Indian"}`,
        `${values.currentaddress || ""}`, `${values.email}`,
        `${values.countrycodecontact || "+91"}`, `${values.contactnumber || ""}`,
        `${values.alternateno || ""}`, `${values.linkedin || ""}`,
        `${values.currentdesignation || ""}`, `${values.currentcompany || ""}`,
        `${values.totalexperience || ""}`, `${values.noticeperiod || ""}`,
        `${values.currentctc || 0}`, `${values.expectedctc || 0}`,
        `${values.qualification || ""}`, `${values.stream || ""}`,
        `${values.institute || ""}`, `${values.passingyear || ""}`,
        `${values.appliedposition}`, `${values.department || ""}`,
        `${values.source || ""}`, `${values.referredby || ""}`,
        `${values.priority || ""}`,`${values.StageID}`,
        `${values.remarks || ""}`,
        `${skills.map((s) => s.recid || s.label).join(",") || ""}`,
        `${existingResumeId ? existingResumeId : resumeid}`,
      ],
    };
}


    const result = await Hexapi(obj);
    if (result?.[""]?.[0]) {
      showConfirm({ content: result[""][0].msg, okText: "OK" });
      if (result[""][0].command == 0) return;
      form.resetFields();
      setSkills([]);
      setResumeFile(null);
      setActiveSection(0);
      // refreshtableadd()
      onClose?.();
    }
  } catch (err) {
    console.log(err, "submit error");
  } finally {
    setSubmitLoading(false);
  }
};

  const handleReset = () => {
    Modal.confirm({
      title: "Reset form?",
      content: "All entered data will be cleared.",
      okText: "Yes, Reset",
      cancelText: "Cancel",
      centered:true,
      onOk: () => {
        form.resetFields();
        setSkills([]);
        setResumeFile(null);
        setActiveSection(0);
      },
    });
  };

  const handleClose = () => {
    form.resetFields();
    setSkills([]);
    setResumeFile(null);
    setActiveSection(0);
    onClose?.();
  };

  const PhoneAddon = (fieldName) => (
    <Form.Item name={fieldName} noStyle initialValue="+91">
      <Select style={{ width: 110 }} showSearch optionFilterProp="children">
        {countrycode.map((c) => (
          <Option key={c.dial_code} value={c.dial_code}>
            {c.dial_code}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
  return (
    <App>
    <Modal
        show={open}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        fullscreen
        dialogClassName="edit-candidate-bootstrap-modal"
      >
        <Modal.Body
          style={{
            padding: 0,
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            background: "#fff",
          }}
        >

        <Card
          style={{ flexShrink: 0, borderRadius: 0, borderLeft: "none", borderRight: "none", borderTop: "none" }}
          bodyStyle={{ padding: "12px 24px" }}
        >
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={4} style={{ margin: 0 }}>{candidateID ? "Edit" : "Add"} Candidate</Title>
            </Col>
            <Col>
              <Space>
                <Button icon={<ClearOutlined />} onClick={handleReset} disabled={submitLoading}>
                  Reset
                </Button>
                <Button
                  type="primary"
                  icon={submitLoading ? <LoadingOutlined /> : <SendOutlined />}
                  onClick={handleSubmit}
                  loading={submitLoading}
                  disabled={formDataLoading}
                >
                  {candidateID ? "Update":"Submit"}
                </Button>
                <Button
        type="text"
        icon={<CloseOutlined style={{marginBottom:"4px"}} />}
        onClick={handleClose}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 36,
          height: 36,
          borderRadius: 8,
        }}
      />
              </Space>
            </Col>
          </Row>
        </Card>

        <Card
          style={{ flexShrink: 0, borderRadius: 0, borderLeft: "none", borderRight: "none" }}
          bodyStyle={{ padding: "14px 24px" }}
        >
          <Steps
            current={activeSection}
            items={STEPS.map((s) => ({ title: s.title, icon: s.icon }))}
            size="small"
            onChange={setActiveSection}
          />
        </Card>

        <div style={{ flex: 1, overflowY: "auto", padding: "16px 16px 80px 16px" }}>
          <Spin
            spinning={formDataLoading}
            tip="Loading form data..."
            indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
          >
            <Card bodyStyle={{ padding: "20px" }}>
              <Form
                preserve={true}
                form={form}
                layout="vertical"

                requiredMark="optional"
              >
                {activeSection === 0 && (
                  <>
                    <Title level={5}>Personal Information</Title>
                    <Text type="secondary">Basic identity details of the candidate</Text>
                    <Divider />
                    <Row gutter={[16, 0]}>
                      <Col xs={24} sm={12}>
                        <FormField name="fullname" label="Full Name" required placeholder="Enter full name" />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField name="dob" label="Date of Birth" type="date" />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField placeholder="Select gender" name="gender" label="Gender" type="select" options={["Male", "Female", "Other"]} />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField name="nationality" label="Nationality" placeholder="e.g. Indian" />
                      </Col>
                      <Col xs={24}>
                        <FormField name="currentaddress" label="Current Address" placeholder="Street, City, State, PIN" />
                      </Col>
                    </Row>
                  </>
                )}


                {activeSection === 1 && (
                  <>
                    <Title level={5}>Contact Details</Title>
                    <Text type="secondary">How to reach this candidate</Text>
                    <Divider />
                    <Row gutter={[16, 0]}>
                      <Col xs={24} sm={12}>
                        <FormField name="email" label="Email ID" type="email" required prefix={<MailOutlined />} placeholder="name@example.com" />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField name="linkedin" label="LinkedIn Profile" prefix={<LinkedinOutlined />} placeholder="https://linkedin.com/in/..." />
                      </Col>
                      <Col xs={24} sm={12}>
                       <Form.Item
  label={
    <>
      Contact Number <span style={{ color: "#ff0000b0", marginLeft:"3px" }}>*</span>
    </>
  }
  name="contactnumber"
  required
  rules={[
    { required: true, message: "Contact number is required" },
    { len: 10, message: "Must be exactly 10 digits" },
    { pattern: /^[0-9]+$/, message: "Numbers only" },
  ]}
>
  <Input
    addonBefore={PhoneAddon("countrycodecontact")}
    placeholder="10-digit number"
    maxLength={10}
    size="large"
  />
</Form.Item>
                      </Col>
                      <Col xs={24} sm={12}>
                        <Form.Item
                          label="Alternate Number"
                          name="alternateno"
                          rules={[{ pattern: /^[0-9]{0,10}$/, message: "Numbers only, max 10 digits" }]}
                        >
                          <Input addonBefore={PhoneAddon("countrycodealt")} placeholder="Optional" maxLength={10} size="large" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}

                {activeSection === 2 && (
                  <>
                    <Title level={5}>Professional Background</Title>
                    <Text type="secondary">Work history and compensation details</Text>
                    <Divider />
                    <Row gutter={[16, 0]}>
                      <Col xs={24} sm={12}>
                        <FormField name="currentdesignation" label="Current / Last Designation" placeholder="e.g. Senior Developer" />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField name="currentcompany" label="Current / Last Company" placeholder="e.g. Infosys Ltd." />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField
                          name="totalexperience"
                          label="Total Experience"
                          type="select"
                          options={formData.experience.map((e) => ({ value: e.recid, label: e.label }))}
                        />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField
                          name="noticeperiod"
                          label="Notice Period"
                          type="select"
                          options={["Immediate", "15 days", "30 days", "60 days", "90 days"]}
                        />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField name="currentctc" label="Current CTC (₹ LPA)" placeholder="e.g. 8.5" />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField name="expectedctc" label="Expected CTC (₹ LPA)" placeholder="e.g. 12" />
                      </Col>
                    </Row>
                  </>
                )}

                {activeSection === 3 && (
                  <>
                    <Title level={5}>Education</Title>
                    <Text type="secondary">Highest academic qualification</Text>
                    <Divider />
                    <Row gutter={[16, 0]}>
                      <Col xs={24} sm={12}>
                        <FormField
                          name="qualification"
                          label="Highest Qualification"
                          type="select"

                          options={formData.qualification.map((q) => ({ value: q.recid, label: q.label }))}
                        />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField name="stream" label="Specialisation / Stream" placeholder="e.g. Computer Science" />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField name="institute" label="Institute / University" placeholder="e.g. Delhi University" />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField
                          name="passingyear"
                          label="Passing Year"
                          placeholder="e.g. 2020"
                          maxLength={4}
                          rules={[{ pattern: /^[0-9]{0,4}$/, message: "Enter valid year" }]}
                        />
                      </Col>
                    </Row>
                  </>
                )}

{activeSection === 4 && (
  <>
    <Title level={5}>Skills</Title>
    <Text type="secondary">Search and add relevant skills</Text>
    <Divider />

    <Row gutter={[16, 16]}>
      <Col xs={24}>
        <Select
         getPopupContainer={(triggerNode) => triggerNode.parentElement}
          mode="multiple"
          showSearch
          placeholder="Search and select skills..."
          size="large"
          style={{ width: "100%" }}
          value={skills.map((s) => s.label)}
          filterOption={(input, option) =>
            option?.label?.toLowerCase().includes(input.toLowerCase())
          }
          onChange={(selectedLabels) => {

            const updated = selectedLabels.map((label) => {
              const existing = skills.find((s) => s.label === label);
              if (existing) return existing;
              const fromBackend = formData.skillname.find((s) => s.label === label);
              return fromBackend || { recid: null, label };
            });
            setSkills(updated);
          }}
          options={formData.skillname.map((s) => ({
            value: s.label,
            label: s.label,
          }))}
          dropdownRender={(menu) => (
            <>
              {menu}
              <Divider style={{ margin: "8px 0" }} />
              <div style={{ padding: "4px 8px 8px" }}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  Can't find your skill? Type and press Enter to add custom
                </Text>
                <Space.Compact style={{ width: "100%", marginTop: 6 }}>
                  <Input
                    placeholder="Type custom skill..."
                    value={skillInput}
                    size="middle"
                    onChange={(e) => setSkillInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        e.stopPropagation();
                        addSkill();
                      }
                    }}
                  />
                  <Button type="primary" icon={<PlusOutlined />} onClick={() => addSkill()}>
                    Add
                  </Button>
                </Space.Compact>
              </div>
            </>
          )}
          tagRender={(props) => {
            const { label, closable, onClose } = props;
            return (
              <Tag
                color="blue"
                closable={closable}
                onClose={onClose}
                style={{ marginInlineEnd: 4, padding: "2px 8px", fontSize: 13 }}
              >
                {label}
              </Tag>
            );
          }}
          notFoundContent={
            <div style={{ textAlign: "center", padding: "12px 0", color: "#999" }}>
              No skills found. Add custom below ↓
            </div>
          }
        />
      </Col>

      {skills.length > 0 && (
        <Col xs={24}>
          <div style={{
            background: "linear-gradient(135deg, #f0f7ff 0%, #f5f0ff 100%)",
            borderRadius: 10,
            padding: "16px 20px",
            border: "1px solid #d6e4ff",
          }}>
            <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
              <Text strong style={{ fontSize: 14 }}>
                🎯 {skills.length} Skill{skills.length > 1 ? "s" : ""} Selected
              </Text>
              <Button
                size="small"
                danger
                type="text"
                onClick={() => setSkills([])}
              >
                Clear All
              </Button>
            </Row>
            <Space wrap size={[8, 8]}>
              {skills.map((s) => (
                <Tag
                  key={s.label}
                  closable
                  onClose={() => removeSkill(s.label)}
                  color={s.recid ? "blue" : "purple"}
                  style={{ fontSize: 13, padding: "4px 12px", borderRadius: 20 }}
                >
                  {s.label}
                  {!s.recid && (
                    <Text style={{ fontSize: 10, color: "#d3adf7", marginLeft: 4 }}>
                      custom
                    </Text>
                  )}
                </Tag>
              ))}
            </Space>
          </div>
        </Col>
      )}
    </Row>
  </>
)}

                {activeSection === 5 && (
                  <>
                    <Title level={4}>Application Details</Title>
                    <Text type="secondary">Role applied for and recruitment metadata</Text>
                    <Divider />
                    <Row gutter={[16, 0]}>
                      <Col xs={24} sm={12}>
                        <FormField required type="select" name="appliedposition" label="Applied for Position" options={formData.appliedpositionfor.map((s) => ({ value: s.recid, label: s.label }))} />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField
                          name="department"
                          label="Department"
                          type="select"
                          options={formData.department.map((d) => ({ value: d.recid, label: d.label }))}
                        />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField
                        required
                          name="source"
                          label="Source of Candidacy"
                          type="select"
                          options={formData.source.map((s) => ({ value: s.recid, label: s.label }))}
                        />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField name="referredby" label="Referred By" placeholder="Name of referrer (if any)" />
                      </Col>
                      <Col xs={24} sm={12}>
                        <FormField
                          name="priority"
                          label="Priority"
                          type="select"
                          options={[
    { label: "High",   value: 1 },
    { label: "Medium", value: 2 },
    { label: "Low",    value: 3 },
]}
                        />
                      </Col>
                      {/* <Col xs={24} sm={12}>
                        <FormField
                          name="StageID"
                          label="Current Stage"
                          type="select"
                          options={formData.stage.map((s) => ({ value: s.recid, label: s.label.trim() }))}
                        />
                      </Col> */}
                       <Col xs={12}>
  <Form.Item
    label={
      <>
        Resume / CV
        <span style={{ color: "#ff0000a2", marginLeft: "6px" }}> * </span>
      </>
    }
    required
    validateStatus={!resumeFile && !existingResumeId ? "error" : ""}
    help={isresume && !resumeFile && !existingResumeId ? "Please upload your resume" : ""}
  >
    {existingResumeId && !resumeFile && (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 12px",
          border: "1px solid #b7eb8f",
          borderRadius: 8,
          background: "#f6ffed",
          marginBottom: 8,
        }}
      >
        <Space>
          <i className="ti ti-file-text" style={{ fontSize: 18, color: "#52c41a" }} />
          <span style={{ fontSize: 13, color: "#389e0d" }}>Existing resume on file</span>
        </Space>
      </div>
    )}
    <Upload
      accept=".pdf,.doc,.docx"
      maxCount={1}
      beforeUpload={(file) => {
        const isLt5MB = file.size / 1024 / 1024 < 5;
        if (!isLt5MB) {
          message.error("File size must be less than 5 MB");
          return Upload.LIST_IGNORE;
        }
        setResumeFile(file);
        return false;
      }}
      onRemove={() => setResumeFile(null)}
      fileList={
        resumeFile
          ? [{ uid: "-1", name: resumeFile.name, status: "done" }]
          : []
      }
    >
{console.log(existingResumeId,"existingResumeId")}
      <Button icon={<UploadOutlined />} size="large">
        {(existingResumeId && !resumeFile)
          ? "Replace Resume"
          : "Click to Upload Resume (PDF, DOC, DOCX)"}
      </Button>
       {
  existingResumeId && <Tooltip title="View Attachment">
              <IconButton onClick={(e) => setopenatachment(true)}> 
                 <FaEye />
                </IconButton>
              </Tooltip>
}
    </Upload>
   
  </Form.Item>
</Col>
                      <Col xs={12}>
                        <FormField name="remarks" label="Remarks / Notes" type="textarea" rows={3} placeholder="Any additional notes about this candidate..." />
                      </Col>

                    </Row>
                  </>
                )}
              </Form>
            </Card>
          </Spin>
        </div>
        <div style={{
          borderTop: "0.5px solid #f0f0f0",
          background: "#fff",
          padding: "12px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexShrink: 0,
        }}>
          <div>
            {activeSection > 0 && (
              <Button icon={<ArrowLeftOutlined />} onClick={goBack} size="large" disabled={submitLoading}>
                Back
              </Button>
            )}
          </div>
          <div>
            {activeSection < STEPS.length - 1 ? (
              <Button
                type="primary"
                iconPosition="end"
                icon={<ArrowRightOutlined />}
                onClick={goNext}
                size="large"
                disabled={formDataLoading || submitLoading}
              >
                Next
              </Button>
            ) : (
              ""
            )}
          </div>
        </div>
        </Modal.Body>
      </Modal>
       {
              (openattachment && existingResumeId) && (
      
                <ViewComponent agentID={agentID} passid={existingResumeId} closeModal={() => setopenatachment(false)} isViewModalOpen={openattachment}/>
              )
            }
    </App>
  );
}